import React from 'react';

function AmplionIcon({ size = 20, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        d="M16 4 L7 28 L11 28 L13 22 L19 22 L21 28 L25 28 Z M14.5 19 L16 11 L17.5 19 Z"
        fill="white"
        opacity="0.95"
      />
      <path
        d="M23 10 C26 13, 26 19, 23 22"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
        opacity="0.6"
      />
      <path
        d="M26 7 C30 11, 30 21, 26 25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        opacity="0.3"
      />
    </svg>
  );
}

export default function Logo({ size = 'md', className = '' }) {
  const config = {
    sm: { icon: 20, iconBox: 'w-6 h-6 rounded-md', text: 'text-lg', gap: 'gap-1.5' },
    md: { icon: 22, iconBox: 'w-8 h-8 rounded-lg', text: 'text-xl', gap: 'gap-2' },
    lg: { icon: 26, iconBox: 'w-10 h-10 rounded-xl', text: 'text-2xl', gap: 'gap-2.5' },
    xl: { icon: 30, iconBox: 'w-12 h-12 rounded-xl', text: 'text-3xl', gap: 'gap-3' },
  };

  const c = config[size] || config.md;

  return (
    <span className={`inline-flex items-center ${c.gap} ${className}`}>
      <span
        className={`${c.iconBox} bg-gradient-to-br from-teal-500 to-teal-700 flex items-center justify-center shadow-sm`}
      >
        <AmplionIcon size={c.icon} />
      </span>
      <span
        className={`font-extrabold tracking-tight ${c.text} text-slate-800 dark:text-slate-100`}
        style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
      >
        amplione
      </span>
    </span>
  );
}
